// src/components/navigation/TopNav.js
//
// Phase 3 - Navigation Architecture: Step 7 reusable navigation component.
//
// Wraps the existing mobile Header. Church-specific navigation now lives in
// the church dashboard tabs instead of a context-aware global nav surface.

import React from "react";
import Header from "../Header";

export default function TopNav({ user, onLogout, supportAction }) {
  return <Header user={user} onLogout={onLogout} supportAction={supportAction} />;
}
